module.exports = __webpack_public_path__ + "static/media/24_FES_v2.36380afe.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle24/24_FES_v2.mp4
 ** module id = 384
 ** module chunks = 0
 **/